import axios from 'axios';
import { emitSessionExpired } from './sessionExpiry';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:8080';

const API_WITH_CREDENTIALS = import.meta.env.VITE_API_WITH_CREDENTIALS === 'true';

// Authenticated actions served under /auth/* - a 401 here means the session
// expired (unlike the login/recovery endpoints), so it should prompt re-login.
const IN_SESSION_AUTH_PATHS = ['/auth/change-password'];

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorData = error.response?.data;
    const path = (error.config?.url ?? '').split('?')[0];

    // /auth/* endpoints are the login/recovery flow: a 401 there is a failed
    // credential, not an expired session, so it must not prompt re-login. The
    // exception is authenticated actions on that prefix (e.g. change-password),
    // where a 401 does mean the session expired.
    const isPreAuthRequest = path.includes('/auth/') && !IN_SESSION_AUTH_PATHS.includes(path);

    const refreshFailed =
      status === 403 && errorData?.error === 'REFRESH_FAILED' && errorData?.message === 'Unable to refresh token';

    if ((status === 401 && !isPreAuthRequest) || refreshFailed) {
      emitSessionExpired();
    }

    return Promise.reject(error);
  },
);

export default apiClient;
